export enum ApplicationType {
    Single,
    CoBorrower,
    Entity
}
